import { useQuery } from '@tanstack/react-query';
import { Card, Dropdown, Modal, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { ReactComponent as Plus } from '../../../assets/add.svg';
import { ReactComponent as Ellipsis } from '../../../assets/ellipsis.svg';
import { getPermissions } from '../request';
import Button from '../../../custom/button/button';
import { useState } from 'react';
import AddPermission from './addPermission';
import EditPermission from './editPermission';
import { getErrorMessage } from '../../../utils/getErrorMessage';

const Permissions = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedPermission, setSelectedPermission] = useState<Permission | null>(null);

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['get-all-permissions'],
    queryFn: getPermissions,
  });

  const toggleAddModal = () => setOpenAdd((prev) => !prev);
  const toggleEditModal = () => setOpenEdit((prev) => !prev);

  const handleEdit = (record: Permission) => {
    setSelectedPermission(record);
    toggleEditModal();
  };

  const columns: ColumnsType<Permission> = [
    {
      key: 'S/N',
      title: 'S/N',
      render: (_text, _record, index) => index + 1,
    },
    // {
    //   key: 'id',
    //   title: 'Permission ID',
    //   dataIndex: 'id',
    // },
    {
      key: 'name',
      title: 'Permission Name',
      dataIndex: 'name',
    },
    {
      key: 'institutionShortName',
      title: 'Institution',
      dataIndex: 'institutionShortName',
    },
    {
      key: 'createdDate',
      title: 'Created Date',
      dataIndex: 'createdDate',
      render: (date: string) => new Date(date).toLocaleDateString(),
    },
    // {
    //   key: 'isActive',
    //   title: 'Status',
    //   dataIndex: 'isActive',
    //   render: (isActive: boolean) => (
    //     <span style={{ color: isActive ? 'green' : 'red' }}>{isActive ? 'Active' : 'Inactive'}</span>
    //   ),
    // },
    {
      key: 'action',
      title: 'Action',
      render: (_, record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: 'Edit Permission',
                key: '1',
                onClick: () => handleEdit(record),
              },
            ],
          }}
          trigger={['click']}
        >
          <Ellipsis />
        </Dropdown>
      ),
    },
  ];

  const permissionData = data?.data as Permission[];

  return (
    <div>
      <section className="space-between">
        <h3>Permissions</h3>
        <Button text="Add Permission" iconBefore={<Plus />} onClick={toggleAddModal} />
      </section>

      <br />

      <Card bordered={false}>
        <Table
          dataSource={permissionData}
          columns={columns}
          rowKey={(record) => record.id}
          scroll={{ x: true }}
          loading={isLoading}
          pagination={false}
          locale={{ emptyText: isError ? getErrorMessage(error) : 'No Permission found' }}
        />
      </Card>

      <Modal title="Add Permission" open={openAdd} onCancel={toggleAddModal} footer={null}>
        <AddPermission handleClose={toggleAddModal} refetch={refetch} />
      </Modal>

      <Modal title="Edit Permission" open={openEdit} onCancel={toggleEditModal} footer={null}>
        {selectedPermission && (
          <EditPermission permission={selectedPermission} handleClose={toggleEditModal} refetch={refetch} />
        )}
      </Modal>
    </div>
  );
};

export default Permissions;
